import $ from 'jquery';
import {Button, ListGroup} from 'react-bootstrap';
import createReactClass from 'create-react-class';

import './QACandidatePanel.css';
import './Common.css';
import QACandidatePanelBottom from './QACandidatePanelBottom.js';
import CONFIG from '../global/libs/CONFIG.js';
import PropTypes from 'prop-types';

/*
    refは以下のようによう書き換える
    参考： https://engineer.blog.lancers.jp/javascript/react_avoid_finddomnode_and_refs_string/
    * DOM要素側
        <div ref={node => this.SomeElement = node}></div>
    * refの参照側
        this.SomeElement && this.SomeElement.callSomeFunction();
*/

let QACandidatePanel = createReactClass({
  propTypes: {
    results: PropTypes.array,
    question: PropTypes.string,
    logId: PropTypes.number,
    cgId: PropTypes.string,
    gotoAnswerPanel: PropTypes.func
  },

  getInitialState() {
    return {expandLevel: 1};
  },

  showHiddenList: function () {
    if (this.state.expandLevel === 1) {
      if (this.hiddenList) {
        $(this.hiddenList).slideDown();
      }
      this.setState({expandLevel: 2});
    } else if (this.state.expandLevel === 2) {
      if (this.showMoreBtn) {
        $(this.showMoreBtn).css('opacity', '0');
      }
      if (this.hiddenList2) {
        $(this.hiddenList2).slideDown();
      }
      this.setState({expandLevel: 3});
    }
  },

  handleCandidateClick: function (result) {
    this.props.gotoAnswerPanel(result);
  },

  convertToPlainText: function (source) {
    // HTMLタグを含む文字列(source)から、タグを除去したテキストを取り出す。
    var $tmp = $('<div>').html(source);
    return $tmp.text();
  },

  resultsMapFunc(result, idx) {
    let resultAnswer = result.answer ? result.answer : '';
    let resultCategory = result.category ? '＜' + result.category + '＞' : '';

    resultAnswer = this.convertToPlainText(resultAnswer);

    let maxAnswerLen = Math.min(resultAnswer.length / 2, 42);
    let category = <span style={{fontSize: '75%'}}>{resultCategory}</span>;
    let header = (
      <div>
        <div>{category}</div>
        <div>
          <span dangerouslySetInnerHTML={{__html: 'Q: ' + result.question}}></span>
        </div>
      </div>
    );

    return (
      <ListGroup.Item
        key={'listGroupItems' + idx}
        onClick={this.handleCandidateClick.bind(null, result)}
        style={{marginBottom: '-1px'}}
      >
        <div className="fw-bold">{header}</div>
        <span className="text-muted">
          A: {resultAnswer.slice(0, maxAnswerLen)}...
          <span className="text-info">詳しく</span>
        </span>
      </ListGroup.Item>
    );
  },

  render: function () {
    let results = this.props.results;
    let question = this.props.question;

    let offset = 0;
    let listGroupItems = results.slice(offset, offset + 5).map(this.resultsMapFunc);
    let listGroupItemsHidden = results.slice(offset + 5, offset + 10).map(this.resultsMapFunc);
    let listGroupItemsHidden2 = results.slice(offset + 10, offset + 15).map(this.resultsMapFunc);

    let score1st = results.length >= 1 ? results[0].score : 0;
    let isSorry = score1st < CONFIG.SCORE_THRESHOLD_FOR_SORRY;

    return (
      <div style={{paddingTop: '10px', paddingBottom: '5px'}}>
        <div style={{paddingBottom: '5px'}} className="center">
          <QACandidatePanelBottom
            question={question}
            isSorry={isSorry}
            logId={this.props.logId}
            cgId={this.props.cgId}
          />
        </div>
        <div>
          &#160;&#160;&#160;<h3 style={{display: 'inline'}}>関連質問一覧</h3>
          <span className="text-muted">（見たい質問をクリックしてください）</span>
        </div>

        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html: 'button.list-group-item{border-left: none; border-rightgg: none;}'
          }}
        />
        <br />
        <ListGroup className="qa-candidate-list">
          {listGroupItems}
          <span ref={(node) => (this.hiddenList = node)} style={{display: 'none'}}>
            {listGroupItemsHidden}
          </span>
          <span ref={(node) => (this.hiddenList2 = node)} style={{display: 'none'}}>
            {listGroupItemsHidden2}
          </span>
        </ListGroup>
        <div ref={(node) => (this.showMoreBtn = node)} className="center showmore">
          <Button onClick={this.showHiddenList} style={{marginTop: 0}}>
            show more...
          </Button>
        </div>
      </div>
    );
  }
});

export default QACandidatePanel;
